export { createClient } from "modules/client/client"

const state = {}

export const registerClient = client => {
  state.client = client
}

export const getClient = () => state.client
